import { createTheme } from '@mui/material';

export const ctaTheme = createTheme({
	palette: {
	  primary: {
		main: '#62361b',
	  },
	  secondary: {
		main: '#009b3a',
	  },
	  error: {
		main: '#c60c30',
	  },
	  info: {
		main: '#00a1de',
	  },
	  background: {
		default: '#eae5e5',
		paper: '#62361b',
	  },
	  text: {
		primary: '#000000',
	  },
	},
  });